import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class RemoveFavoriteProjectCommand {
  constructor(private httpClient: HttpClient) {}

  call(organizationId: number, projectId: number): Observable<any> {
    const url = `${environment.api.pm}/organizations/${organizationId}/favorite_projects`

    const params = { project_id: projectId }

    return this.httpClient.delete(url, { params }).pipe(
      map(() => {
        return null
      })
    )
  }
}
